import { CanActivateFn, Router } from '@angular/router';
import { AuthUseCaseService } from '../../../auth/application/auth-use-case.service';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { customToast } from '@ui/shared/adapters/notify-toasts';

export const validateTokenGuard: CanActivateFn = (route, state) => {
  const authUseCaseService = inject(AuthUseCaseService);
  const router = inject(Router);

  return authUseCaseService.getSession().pipe(
    map((sessionResponse) => {
      if (!sessionResponse.isValid) {
        customToast({
          title: 'Error de sesión',
          message: sessionResponse.message,
          icon: 'error',
        });

        router.navigate(['/login']);
        return false;
      }
      return true;
    })
  );
};
